<template>
  <div id="map-container" class="columns is-gapless" style="margin-bottom: 0" :class="mapHeight">
    <gmap-map
        ref="googleMap"
        :center="mapCenter"
        @click="onMapClicked"
        :zoom="mapZoom"
        :heading="heading"
        :options="options"
        map-type-id="terrain"
        style="width: 100%"
        class="mapbox-container">

      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen"
                        @closeclick="onCloseInfoWindow">
      </gmap-info-window>
      <gmap-circle v-for="item in radiuses" :center="item.center" :radius="item.radius" :fillOpacity="0.1"  :strokeOpacity="0.5" :key="JSON.stringify(item)"></gmap-circle>

      <my-google-marker v-for="(item, index) in markers" :key="JSON.stringify(item)"
                        :item="item"
                        @onMarkerClicked="onMarkerClicked(item, index)"
                        :is-selected="selectedDevice === item"
                        :draw-mode="null">
      </my-google-marker>
    </gmap-map>
  </div>
</template>

<script>
import MyGoogleMarker from "@/modules/projects-module/components/my-google-marker/my-google-marker.vue";
import {mapGetters} from "vuex";
import {bbox, lineString} from "@turf/turf";
import {
  getGMapPopupComparableSites, gMapStyles
} from "@/utils/utils";

export default {
  name: "g-map-matching-sites",
  components: { MyGoogleMarker},
  props:{
    devices: {
      type: Array,
      default: () => {
      },
      immediate: true,
    },
  },
  data() {
    return {
      mapCenter: {lat: -37.80193, lng: 144.94444},
      mapData: [],
      mapZoom: 8,
      drawMode: null,
      heading: 0,
      options: {styles: gMapStyles},
      selectedDevice: null,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -16
        }
      },
      filter: {site: true, device: true, sitePlan: true, planDevice: true}
    }
  },
  async mounted() {
    await this.$gmapApiPromiseLazy();

    console.log('Map: ', this.$refs.googleMap)


    this.$refs.googleMap.$mapObject.addListener('projection_changed', () => {
      console.log('Map heading', this.$refs.googleMap.$mapObject.heading)
      this.heading = this.$refs.googleMap.$mapObject.heading
    });

    this.zoomMapToSelectedSiteOrProject(true)

  },
  methods: {
    onCloseInfoWindow() {
      this.infoWinOpen = false
      this.selectedDevice = null
      //this.zoomMapToSelectedSiteOrProject(true)
    },
    onMapClicked() {
      console.log('On map clicked')
      this.$emit('onMapClicked')
      this.selectedDevice = null
      if (!this.infoWinOpen) {
        this.zoomMapToSelectedSiteOrProject(true)
      }
      this.infoWinOpen = false
    },
    onMarkerClicked(device, index) {
      console.log('On marker clicked', device)
      if (this.selectedDevice === device) {
        this.selectedDevice = null
      } else {
        this.selectedDevice = device
      }

      this.zoomMapToSelectedSiteOrProject(true)
      this.toggleInfoWindow(device, index)
    },
    selectSite(site) {
        this.selectedDevice = site
      this.zoomMapToSelectedSiteOrProject(true)
      //this.toggleInfoWindow(device, index)
    },
    toggleInfoWindow(site, idx) {
      this.infoWindowPos = {lat: site.location.coordinates[1], lng: site.location.coordinates[0]};
      this.infoOptions.content = getGMapPopupComparableSites(site)
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }

      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    zoomMapToSelectedSiteOrProject(animate) {
      console.log('GMap, zoom to projects or sites')
      if (this.selectedProject != null) {
        //Zoom to selected site
        let coordinates = []
        console.log('GMap, zoom to projects or sites, selected device: ', this.selectedDevice)
        console.log('GMap, zoom to projects or sites, selected devices: ', this.devices)
        console.log('GMap, zoom to projects or sites, selected project: ', this.selectedProject)
        if (this.selectedDevice != null) {
          coordinates.push(this.selectedDevice.location.coordinates)
          //return
        } else {
          if(this.devices){
            coordinates.push(...this.devices.map(device => {
              return device.location.coordinates
            }))
          }

        }

        if (coordinates.length > 0) {
          if (coordinates.length === 1) {
            this.$refs.googleMap.$mapObject.setZoom(16)
            this.$refs.googleMap.$mapObject.panTo({lat: coordinates[0][1], lng: coordinates[0][0]});

          } else {
            let line = lineString(coordinates);
            let bb = bbox(line);
            console.log('Bounding box:', bb)
            let boundsGMap = new window.google.maps.LatLngBounds()
            boundsGMap.extend({lat: bb[1], lng: bb[0]})
            boundsGMap.extend({lat: bb[3], lng: bb[2]})
            console.log('LatLngBounds: ', boundsGMap)
            this.$refs.googleMap.$mapObject.fitBounds(boundsGMap);
          }

        } else if (animate) {
          this.$refs.googleMap.$mapObject.panTo(this.mapCenter);
        }
      } else {
        this.$refs.googleMap.$mapObject.panTo(this.mapCenter);
      }
    },
  },
  computed: {
    ...mapGetters({
      selectedProject: 'projectsModule/getSelectedProject'
    }),
    mapHeight() {
      if (this.selectedProject == null) {
        return 'full-height-map'
      } else {
        return 'smaller-height-map'
      }
    },
    markers() {
      let sites = []

      let allMarkers = []

      if (this.devices && this.devices.length > 0) {
        this.devices.forEach(site => {
          let siteMarker = Object.assign({}, site)
          if (this.filter.site) {
            sites.push(siteMarker)
          }
          if(siteMarker.matchingSites && siteMarker.matchingSites.length > 0){
            siteMarker.matchingSites.forEach(match => {
              let mSite = JSON.parse(JSON.stringify(match))
              mSite.color = mSite.isMatching ? '#000000' : '#ff0000'
              sites.push(mSite)
            })
          }

        })
      }

      allMarkers.push(...sites)

      console.log('All markers: ', allMarkers)

      return allMarkers
    },
    radiuses(){

      let allMarkers = []

      if (this.devices && this.devices.length > 0) {
        this.devices.forEach(site => {
          if(site.objectType === 'site-match'){
            let radiusArea = {
              center: {lat: site.location.coordinates[1], lng: site.location.coordinates[0]},
              radius: 500,
            }
              allMarkers.push(radiusArea)
          }
        })
      }

      console.log('All markers: ', allMarkers)

      return allMarkers
    }
  },
  watch: {
    selectedProject: {
      handler: function (newVal, oldVal) {
        console.log('Selected project changed:', this.selectedProject)
        this.zoomMapToSelectedSiteOrProject(true)
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>